import {Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {MembershipService} from '~core/services';
import {CampaiMembership, Club, Customer} from '~core/models';
import {TooltipTranslationService} from '~shared/translations';

/**
 * Displays customer data inside an info tile
 */
@UntilDestroy()
@Component({
  selector: '[app-customer-data-info]',
  templateUrl: './customer-data-info.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class CustomerDataInfoComponent implements OnInit {
  @Input() public customer: Customer;
  @Input() public selectedClub: Club;
  public currentMembership: CampaiMembership;

  constructor(
    public customerService: CustomerOverViewService,
    public tooltipTranslations: TooltipTranslationService,
    public membershipService: MembershipService,
  ) {
  }

  public ngOnInit(): void {
    this.membershipService.castCurrentMembership.pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data !== null) {
          this.currentMembership = data;
        }
      });
  }

  /**
   * Open the edit customer modal and fill the form.
   */
  public editCustomer(): any {
    this.customerService.toggleAllModal(false);
    this.customerService.toggleEditCustomerModal(true);
  }

  /**
   * Returns the age of the user
   */
  public getAge(birthday: any): any {
    const today = new Date();
    const birthDate = new Date(birthday);
    const m = today.getMonth() - birthDate.getMonth();
    let age = today.getFullYear() - birthDate.getFullYear();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}
